if (!customElements.get('nav-blocker-popup')) {
  customElements.define(
    'nav-blocker-popup',
    class NavBlockerPopup extends DrawerComponent {
      constructor() {
        super();
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        if (Shopify.designMode) return;

        this.initNavBlocker();
      }

      initNavBlocker() {
        const headerNav = document.querySelector('.header__navigation');
        const menuDrawer = document.querySelector('#MenuDrawer');

        if (headerNav) {
          this.interceptNav(headerNav);
        }

        if (menuDrawer) {
          this.interceptNav(menuDrawer);
        }
      }

      interceptNav(container) {
        container.addEventListener('click', (event) => {
          const link = event.target.closest('a');
          const summary = event.target.closest('summary[data-link]');

          if (!link && !summary) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          if (summary) {
            const details = summary.closest('details');
            if (details) {
              details.removeAttribute('open');
            }
          }

          this.show();
        }, true);
      }
    }
  );
}